import React from 'react';
import { TableHeader as TableHeaderContainer, HeaderCell, RowContent, RequestContainer, CreatedContainer, ServiceContainer, TypeContainer, StatusContainer, RemindersContainer, } from './styles';
var headerColumns = [
    { label: 'Solicitud', Container: RequestContainer },
    { label: 'Creado', Container: CreatedContainer },
    { label: 'Servicio', Container: ServiceContainer },
    { label: 'Tipo', Container: TypeContainer },
    { label: 'Estado', Container: StatusContainer },
    { label: 'Recordatorios', Container: RemindersContainer },
];
export var TableHeader = function (_a) {
    var _b = _a.hideReminders, hideReminders = _b === void 0 ? false : _b, _c = _a.isClientView, isClientView = _c === void 0 ? false : _c;
    var visibleColumns = hideReminders
        ? headerColumns.filter(function (column) { return column.label !== 'Recordatorios'; })
        : headerColumns;
    return (React.createElement(TableHeaderContainer, { isClientView: isClientView },
        React.createElement(RowContent, { isClientView: isClientView }, visibleColumns.map(function (_a, index) {
            var label = _a.label, Container = _a.Container;
            return (React.createElement(Container, { key: index, isClientView: isClientView },
                React.createElement(HeaderCell, null, label)));
        }))));
};
